import PropTypes from 'prop-types'
import { createContext, useContext, useMemo } from 'react'

const PartnerContext = createContext()

PartnerContext.displayName = 'PartnerContext'

export function PartnerContextProvider(props) {
  const value = useMemo(() => {
    const report_v1_settings = JSON.parse(
      props.partner.app_settings?.report_v1_settings || '{}'
    )

    const report_v2_settings = JSON.parse(
      props.partner.app_settings?.report_v2_settings || '{}'
    )

    const dashboard_settings = JSON.parse(
      props.partner.app_settings?.dashboard_settings || '{}'
    )

    const isV1ScoreVisible = report_v1_settings.score_visible ?? true
    const isV2ScoreVisible = report_v2_settings.score_visible ?? true

    // Dashboard component visibility settings
    // Components are visible by default, only hidden if explicitly set to false
    const isDashboardComponentVisible = {
      assessmentMonitor:
        dashboard_settings.assessment_monitor_visible !== false,
      culturalFit: dashboard_settings.cultural_fit_visible !== false,
      matching: dashboard_settings.matching_visible !== false
    }

    return {
      partner: {
        ...props.partner,
        isV1ScoreVisible,
        isV2ScoreVisible,
        isDashboardComponentVisible
      },
      refetchPartner: props.refetchPartner
    }
  }, [props.partner, props.refetchPartner])

  return <PartnerContext.Provider value={value} {...props} />
}

PartnerContextProvider.propTypes = {
  partner: PropTypes.object.isRequired,
  refetchPartner: PropTypes.func.isRequired
}

export function usePartnerContext() {
  const context = useContext(PartnerContext)

  if (!context) {
    throw new Error('usePartnerContext must be used within a AppProvider')
  }

  return context
}
